import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IAffiliateGetTrackersSettingsResponse } from '../types';
import { AFFILIATE_GET_TRACKERS_SETTINGS_API_URL, AFFILIATE_GET_TRACKERS_SETTINGS_QUERY } from '../constants';

export default function useGetAffiliateTrackersSettingsQuery(id: Ref<number>): IContextQueryResult<
  IAffiliateGetTrackersSettingsResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateGetTrackersSettingsResponse>({
    queryKey: [AFFILIATE_GET_TRACKERS_SETTINGS_QUERY, id],
    queryFn: ({ signal }) => fetchGet<IAffiliateGetTrackersSettingsResponse>(
      AFFILIATE_GET_TRACKERS_SETTINGS_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
